import styled from '@emotion/styled'
import { Picture } from 'components/picture/Picture'
import { Stack } from 'components/Stack'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SWizardHeroGrid = styled.section`
  display: grid;
  grid-template-columns: 1fr ${pxToRem(325)}rem;

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 100%;
  }
  grid-gap: 1rem;
`

export const SStack = styled(Stack)`
  @media ${BREAKPOINTS.MD.min} {
    max-width: 32.5rem;
  }
`

export const SPicture = styled(Picture)`
  width: 100%;
  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`
